module.exports = __webpack_public_path__ + "static/media/img5.6fc4e25d.svg";